import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to extract and manage query parameters from the URL.
 * @returns {URLSearchParams} - The URLSearchParams object containing the query parameters.
 */
export const useSearchParams = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};
